"use client";

import ChippyPrompt from "./components/ChippyPrompt/ChippyPrompt";
import Layout from "./components/Layout/LayoutLanding";
// import { trackAddExtensionClick } from "./utils/trackButtonEvent";
import FolderSvg from "./components/svgs/folder/FolderSvg";
import { ChippyPromptImage } from "./components/ChippyPrompt/ChippyPromptWrapper";
// import YTVideo from "./components/YTVideo/YTVideo";
import Video from "./components/Video/Video";
import { useTheme } from "./providers/ThemeProvider";
import FooterHomeNew from "~app/components/Footer/FooterHomeNew";

const ChippyPromptPopUp = () => {
  return (
    <div className="chippy-prompt">
      <div className="prompt-box">
        <>
          <p>Hi! I&rsquo;m Chippy!</p>
          {/* use h1 for seo purposes */}
          <h1 className="main-header">
            A browser extension that lets you bring ChatGPT wherever you go
            online.
          </h1>
          <a href="https://chrome.google.com/webstore/detail/chippy-%E2%80%94-chatgpt-at-your/fbcdphjbmledkhefgamfaleobmegjojl">
            Add Extension
          </a>
          <svg
            width="29px"
            height="10px"
            viewBox="0 0 29 10"
            className="message-arrow"
          >
            <title>Submit Message</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g
                id="Rectangle-18"
                transform="translate(0.468300, 0.000000)"
                fill="currentColor"
                fillRule="nonzero"
              >
                <path d="M27.8577,0 C23.2594,0 19.5317,3.728 19.5317,8.326 C19.5317,8.944 18.7847,9.254 18.3475,8.817 L16.2597,6.731 C11.946,2.421 6.0977,0 0,0 C6.47068611,0 11.3237007,0 14.5590438,0 C17.5143007,0 21.9471861,0 27.8577,0 Z" />
              </g>
            </g>
          </svg>
        </>
      </div>
      <div className="promptImage-wrapper">
        <ChippyPromptImage />
      </div>
    </div>
  );
};

export default function Home() {
  const { theme } = useTheme();
  return (
    <Layout>
      {theme === "window98" && <ChippyPrompt />}
      <ChippyPromptPopUp />
      <div className="main-container chippy-background--fixed">
        <FolderSvg />
        <div className="section-wrapper">
          <section className="origin-story prose">
            <h2 className="heading">ChatGPT at your fingertips</h2>
            <p className="info-label">
              Use AI to summarize, research, translate and answer questions—all
              without switching tabs.
            </p>
            <div className="image">
              <Video src="https://res.cloudinary.com/fictive-kin/video/upload/v1693252108/chippy/chippy_question.mov" />
            </div>
            <div className="flex">
              <div className="info-text-container">
                <h2>Easy input</h2>
                <p>
                  No more endless copy/paste — Just type your question or select
                  the text you want Chippy to look at.
                </p>
              </div>
              <div className="info-image">
                <img
                  className="screenshot not-prose"
                  alt="Screenshot"
                  src="/easy-input.png"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="flex">
              <div className="info-image position-bottom">
                <img
                  className="screenshot not-prose"
                  alt="Screenshot"
                  src="/prompts.png"
                  loading="lazy"
                />
              </div>
              <div className="info-text-container">
                <h2>Suggested prompts</h2>
                <p>
                  Get started with suggested prompts and dig deeper with
                  relevant follow-ups.
                </p>
              </div>
            </div>
            <div className="flex">
              <div className="info-text-container">
                <h2>Focused search</h2>
                <p>
                  Narrow Chippy&rsquo;s search to the current page for
                  information beyond ChatGPT&rsquo;s 2021 knowledge cutoff.
                </p>
              </div>
              <div className="info-image">
                <img
                  className="screenshot not-prose"
                  alt="Screenshot"
                  src="/search.png"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="flex">
              <div className="info-image position-bottom">
                <img
                  className="screenshot not-prose"
                  alt="Screenshot"
                  src="/email.png"
                  loading="lazy"
                />
              </div>
              <div className="info-text-container">
                <h2>Email assistant</h2>
                <p>Open Chippy when you need help drafting a quick reply.</p>
              </div>
            </div>
          </section>
          <section className="faq">
            <div>
              <img
                className="screenshot not-prose"
                alt="Screenshot"
                src="/faq.svg"
              />
            </div>
            <div>
              <div>
                <h2>Is Chippy Free?</h2>
                <p>
                  Yes! Chippy provides twenty free GPT-3.5 queries daily. For
                  more queries or to use GPT-4, you must provide your OpenAI API
                  key.
                </p>
              </div>
              <div>
                <h2>What&rsquo;s the catch?</h2>
                <p>
                  No catch! We just wanted a fun way to bring ChatGPT to the
                  web.
                </p>
              </div>
              <div>
                <h2>How does Chippy protect my data?</h2>
                <p>
                  Your conversations and your API key are stored locally in your browser
                  which you can delete at any time.
                </p>
                <br />
                <p>
                  Chippy does not track your browser history and doesn&rsquo;t
                  require an account to get started.
                </p>
              </div>
              <div>
                <h2>How do I install Chippy?</h2>
                <p>To install Chippy in your Chrome browser:</p>
                <ul>
                  <li>Click “Add Extension”.</li>
                  <li>
                    You&rsquo;ll be directed to the Chrome store. Click “Add to
                    Chrome”.
                  </li>
                  <li>
                    Once installed, select your theme and Chippy is ready to go!
                  </li>
                </ul>
              </div>
              <div>
                <h2>How do I upgrade Chippy?</h2>
                <ul>
                  <li>Open Chippy and click “Settings”.</li>
                  <li>Click “Upgrade”.</li>
                </ul>
              </div>
              <div>
                <h2>What browsers are supported?</h2>
                <p>
                  Chippy currently supports Google Chrome and Chromium-based
                  browsers.
                </p>
              </div>
            </div>
          </section>
          {/* <section className="faq">
            <YTVideo link="https://youtube.com/embed/MIvsZYbUjGM" />
          </section> */}
          {/* <section className="faq">
            <div className="promptImage-wrapper download">
              <ChippyPromptImage alternative={true} />
              <div>
                <a
                  href="https://chrome.google.com/webstore/detail/chippy-%E2%80%94-chatgpt-at-your/fbcdphjbmledkhefgamfaleobmegjojl"
                  onClick={() =>
                    trackAddExtensionClick({
                      location: "homepage",
                    })
                  }
                  className="download-chippy button button--active"
                >
                  Download Chippy
                </a>
              </div>
            </div>
          </section> */}
          <section className="faq">
            <a href="https://www.producthunt.com/posts/chippy?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-chippy" target="_blank">
              <img 
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=414384&theme=light" 
                alt="Chippy - AI&#0032;browser&#0032;assistant&#0032;for&#0032;wherever&#0032;you&#0032;go&#0032;online | Product Hunt" 
                style={{width: '250px', height: '54px'}} 
              />
            </a>
            <FooterHomeNew />
          </section>
        </div>
      </div>
    </Layout>
  );
}
